import { render, staticRenderFns } from "./ImageTopic.vue?vue&type=template&id=4982f743&scoped=true"
import script from "./ImageTopic.vue?vue&type=script&lang=js"
export * from "./ImageTopic.vue?vue&type=script&lang=js"
import style0 from "./ImageTopic.vue?vue&type=style&index=0&id=4982f743&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4982f743",
  null
  
)

export default component.exports